import { render } from "./UIFooter.vue?vue&type=template&id=628a80a2&scoped=true"
import script from "./UIFooter.vue?vue&type=script&lang=js"
export * from "./UIFooter.vue?vue&type=script&lang=js"

import "./UIFooter.vue?vue&type=style&index=0&id=628a80a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628a80a2"]])

export default __exports__